import 'core-js'
import 'react-app-polyfill/ie11'
import React from 'react'
import ReactDOM from 'react-dom'
import { PostHogProvider } from '@posthog/react'
import ApplicationMonitoring from 'core/ApplicationMonitoring'

const posthogKey = process.env.REACT_APP_POSTHOG_KEY
const posthogHost = process.env.REACT_APP_POSTHOG_HOST

const options = {
  api_host: posthogHost,
  autocapture: true,
  capture_pageview: true,
  capture_pageleave: true,
  loaded: (posthog: any) => {
    if (process.env.NODE_ENV === 'development') {
      posthog.debug()
    }
  }
}

ReactDOM.render(
  <React.StrictMode>
    {posthogKey ? (
      <PostHogProvider apiKey={posthogKey} options={options}>
        <ApplicationMonitoring />
      </PostHogProvider>
    ) : (
      <ApplicationMonitoring />
    )}
  </React.StrictMode>,
  document.getElementById('root'),
)